enum ApiErrorsEnum {
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NO_RECORDS_FOUND = 'NO_RECORDS_FOUND',
}

export { ApiErrorsEnum };
